export interface EditLocationsRequest {
  id?: string;
  jobId?: string;
  prevJobId?: string;
  sequenceNumber?: number;
  previousSequenceNumber?: number;
  stopNumber?: number;
  previousStopNumber?: number;
  isDuplicate?: boolean;
  segment?: string;
  productId?: string;
  activityName?: string;
  locationId?: string;
  planId?: string;
  locationAddress?: string;
}
